import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtIsExpired } from "../utils/jwtUtils";
import { PermissionProvider } from "./PermissionProvider";
import { urlDoLoginComVoltar } from "./voltar";
import { bare } from "../services/axios";
import { getRefreshToken, renew } from "../services/session";

interface PrivateRouteProps {
  component: React.ComponentType<any>;
}

type Renovacao = "pendente" | "ok" | "falhou";

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
}) => {
  const { pathname, search } = useLocation();
  const [renovacao, setRenovacao] = useState<Renovacao>("pendente");
  const jwtToken = localStorage.getItem("jwtToken");
  const isJwtIsExpired = jwtIsExpired(jwtToken);
  const temRefresh = !!getRefreshToken();

  // Acesso vencido com refresh guardado (o acesso dura 30 min, o refresh 30 dias): renova em vez
  // de expulsar. Ao abrir um link fundo com a aba parada há horas, a pessoa não vê a tela de login.
  useEffect(() => {
    if (!isJwtIsExpired || !temRefresh) return;
    let vivo = true;
    setRenovacao("pendente");
    renew((body) => bare.post("/Auth/Refresh", body)).then((novo) => {
      if (vivo) setRenovacao(novo ? "ok" : "falhou");
    });
    return () => {
      vivo = false;
    };
  }, [isJwtIsExpired, temRefresh]);

  if (isJwtIsExpired) {
    // Sem refresh, ou o refresh foi recusado: login, levando o caminho que a pessoa abriu para
    // voltar a ele depois de entrar.
    if (!temRefresh || renovacao === "falhou") {
      return <Navigate to={urlDoLoginComVoltar(pathname, search)} />;
    }
    if (renovacao === "pendente") {
      return (
        <div className="flex min-h-dvh w-full items-center justify-center px-6">
          <p role="status" className="text-sm font-medium text-gray-600 dark:text-gray-300">
            Renovando sua sessão…
          </p>
        </div>
      );
    }
  }

  // O provider entra AQUI, dentro do guard de token: fora dele, montaria na tela de login e
  // pediria permissões sem credencial.
  return (
    <PermissionProvider>
      <Component />
    </PermissionProvider>
  );
};

export default PrivateRoute;
